






































// Components
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import ConfirmationModal from "@/components/Organisms/ConfirmationModal.vue";

import { PodeSolicitarProgramaTodaVida, SolicitarInclusaoProgramaTodaVida } from "@/api/health-programs";

import { defineComponent, getCurrentInstance, onMounted, ref } from "vue";

export default defineComponent({
  components: { FixedButtonRow, ConfirmationModal },
  setup() {
    const protocolo = ref("");
    const podeSolicitar = ref(false);
    const context = getCurrentInstance().proxy;

    const register = async () => {
      const response = await SolicitarInclusaoProgramaTodaVida();
      if (response instanceof Error) {
        context.$toast({
          title: response.message,
          status: "error",
          duration: 10000,
          position: "top"
        });
      } else {
        protocolo.value = response.ProtocoloANS;
      }
    };

    onMounted(async () => {
      const response = await PodeSolicitarProgramaTodaVida();
      podeSolicitar.value = response.podeSolicitar;
      context.$root.$emit("hide-loading");
    });

    return {
      protocolo,
      podeSolicitar,
      register
    };
  },
  computed: {
    title() {
      switch (this.$route.name) {
        case "programas_de_saude.home":
          return "Programas de saúde";
        case "programas_de_saude.manifesto":
        case "programas_de_saude.como_funciona":
          return "Como o programa funciona";
      }
    },
    showFooter() {
      return this.$route.name === "programas_de_saude.home";
    }
  }
});
